<template>
    <div class="block-box">
        <div class="block-item">
            <div class="label">
                {{configData.title}}
            </div>
            <el-cascader v-model="configData.activeValue" :options="treeSelect" :props="{
                checkStrictly: true,
                emitPath: false,
                label: 'name',
                value: 'id'
            }" clearable />
        </div>
    </div>
</template>

<script>
    export default {
        name: "category",
        props: {
            configData: {
                type: Object,
                default: {}
            },
        },
        created() {
            this.getList()
        },
        data () {
            return {
                treeSelect: [
                ],
                loading: false
            }
        },
        methods: {
            // 列表
            getList() {
                this.loading = true;
                this.axios.post('store/category/tree', {}).then((res) => {
                    if (res.code == 1) {
                        this.treeSelect = res.data.list
                        this.loading = false;
                    }
                })
            },
        }
    }
</script>

<style scoped>

</style>
